import { useState, useEffect } from "react";
import axios from "axios";
import { FaChevronDown, FaPlay, FaTimes } from "react-icons/fa";
import { Loading } from "../Other/Loading";

const DigitalWorkforceSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [data, setData] = useState(null);
  const [showVideo, setShowVideo] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);

  useEffect(() => {
  const fetchData = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/forbusiness`);
        console.log("API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("//////////////API Response  :////////////", events);
        setData(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
  };

  fetchData();
}, []);

  // Prevent background scrolling when modal is open
  useEffect(() => {
    if (showVideo || showContactForm) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [showVideo, showContactForm]);


  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (!data) return <p><Loading/></p>;

  return (
    <div className="bg-[white] py-12 px-6">
      <h2 className="text-3xl md:text-3xl font-bold text-center mb-8">
        {data.heading}
        
      </h2>
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start gap-8">
        {/* Accordion Section */}
        <div className="w-full md:w-1/2">
          {Array.isArray(data.items) && data.items.length > 0 ? (
            data.items.map((item, index) => (
              <div key={index} className="border-b border-gray-300 cursor-pointer" onClick={() => toggleAccordion(index)} >
                <div className="flex justify-between items-center p-4">
                  <div className="flex items-center gap-3">
                    <img src={`${process.env.REACT_APP_COURSE_API_BASEURL}${item.icon}`} alt={item.title} className="w-6 h-6" />
                    <span className="font-semibold text-lg">{item.title}</span>
                  </div>
                  <FaChevronDown
                    className={`transition-transform ${openIndex === index ? "rotate-180" : ""}`}
                  />
                </div>
                {openIndex === index && (
                  <p className="p-4 text-gray-600">{item.description}</p>
                )}
              </div>
            ))
          ) : null}
        </div>

        {/* Video Section */}
        <div className="w-full md:w-1/2 flex justify-center">
          <div className="relative w-full max-w-md">
            <img
              src={`${process.env.REACT_APP_COURSE_API_BASEURL}${data.videoThumbnail}`}
              alt="Video Thumbnail"
              className="rounded-lg shadow-md w-full"
            />
            <button
              className="!absolute inset-0 flex items-center justify-center"
              onClick={() => setShowVideo(true)}
            >
              <div className="bg-white p-3 rounded-full shadow-lg">
                <FaPlay className="text-blue-600 text-xl" />
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Contact Button */}
      <div className="flex justify-center mt-8 mb-24">
        <button
          onClick={() => setShowContactForm(true)}
          className="px-6 py-3 rounded-lg font-semibold bg-blue-600 text-white hover:bg-blue-700 text-lg"
        >
          {data.buttonText}
        </button>
      </div>

      {/* Video Popup */}
      {showVideo && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-4 rounded-lg max-w-xl w-full relative">
            <button
              className="!absolute mb-[310px] right-2 text-gray-600 hover:text-black"
              onClick={() => setShowVideo(false)}
            >
              <FaTimes />
            </button>
            <iframe
              width="100%"
              height="315"
              src={data.videoLink}
              title="Video"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}

      {/* Contact Form Popup */}
      {showContactForm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 mt-[100px]">
          <div className="bg-white p-6 rounded-lg w-[80%] md:w-[400px] shadow-lg relative ">
            <button
              className="!absolute mb-[420px] right-2 text-gray-600 hover:text-black"
              onClick={() => setShowContactForm(false)}
            >
              <FaTimes />
            </button>
            <h2 className="text-center text-2xl font-bold mb-4">Contact Us</h2>
            <form className="space-y-2">
              <input type="text" placeholder="First Name" className="w-full p-2 border rounded" />
              <input type="text" placeholder="Last Name" className="w-full p-2 border rounded" />
              <input type="email" placeholder="Work Email" className="w-full p-2 border rounded" />
              <input type="text" placeholder="Phone Number" className="w-full p-2 border rounded" />
              <input type="text" placeholder="Company Name" className="w-full p-2 border rounded" />

              {/* Privacy Policy */}

              <div className="flex items-start">
                <div >
                  <input
                    type="checkbox"
                    id="policy"
                    className="!w-5 h-5 accent-blue-600 cursor-pointer mt-0.5 mr-1"
                  />
                </div>
                <div>
                  <label htmlFor="policy" className="text-sm  text-gray-700 leading-snug">
                    By providing your contact details, you agree to our <br />
                    <a href="#" className="text-blue-600 hover:underline">Privacy Policy</a>
                  </label>
                </div>
              </div>
              {/* Submit Button */}
              <button className="w-full bg-blue-600 text-white p-3 rounded hover:bg-blue-700">
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DigitalWorkforceSection;
